import React from 'react';

const AngleIcon = props => (
    <svg xmlns="http://www.w3.org/2000/svg" width={props?.size || "154"} height={props?.size || "98"} viewBox="0 0 154 98" {...props}>
        <defs>
        <linearGradient id="iyf2lutzaa" x1="35.019%" x2="67.721%" y1="45.853%" y2="63.993%">
            <stop offset="0%" stopColor="#FB6E00"/>
            <stop offset="100%" stopColor="#FA3800"/>
        </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
        <g fill="url(#iyf2lutzaa)" transform="translate(-945 -1553)">
            <path d="M1005 1553L1099 1553 1039 1651 945 1651z"/>
        </g>
    </g>
</svg>
)

export default AngleIcon;